"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoetryCountTotal = void 0;
var request_1 = __importDefault(require("@/utils/request"));
function getPoetryCountTotal() {
    return (0, request_1.default)({
        url: "/ancient/poetry/count/",
        method: "get",
    });
}
exports.getPoetryCountTotal = getPoetryCountTotal;
